import React from 'react'
import { Icon } from 'semantic-ui-react'
import './DashboardWidgets.css'

// Shared presentational building blocks for team-based dashboards
// (Manager Dashboard, Asset Dashboard). Keep these purely presentational.

export const SummaryCard = ({ label, value, sub, icon, color, alert }) => (
  <div className={`mgr-summary-card${alert ? ' mgr-summary-card--alert' : ''}`}>
    <div className="mgr-summary-card__label">
      {icon && <Icon name={icon} style={{ color: color || '#888', margin: 0 }} />}
      {label}
    </div>
    <div className="mgr-summary-card__value" style={{ color: color || '#222' }}>{value}</div>
    {sub && <div className="mgr-summary-card__sub">{sub}</div>}
  </div>
)

export const FilterPill = ({ label, active, onClick }) => (
  <button className={`mgr-pill${active ? ' mgr-pill--active' : ''}`} onClick={onClick}>
    {label}
  </button>
)

export const StatusPill = ({ count, label, bg, color, dot }) => (
  <span className="tp-status-pill" style={{ background: bg, color }}>
    {dot && <span className="tp-status-dot" style={{ background: dot }} />}
    {count} {label}
  </span>
)

export const MiniSectionHeader = ({ title, count, alert }) => (
  <div className="tp-section-header">
    {title}
    {count !== undefined && (
      <span className="tp-section-header__badge">{count}</span>
    )}
    {alert && <Icon name="warning sign" color="orange" size="small" style={{ margin: 0 }} />}
  </div>
)
